import * as React from "react";
import { Box } from "@mui/material";
import { AboutUsComp, AboutUsContent, VideoContent } from "./styles";
import thumbnail from "../../../../../assets/images/landingPage/video_logo.jpg";

const Video: React.FC = () => {
  const [playVideo, setPlayVideo] = React.useState(false);

  const handlePlay = () => setPlayVideo(true);

  return (
    <AboutUsComp id="nossol">
      <AboutUsContent>
        <VideoContent>
          {playVideo ? (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%", // 16:9
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/-5TiMhmaYVs?autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </Box>
          ) : (
            <Box
              onClick={handlePlay}
              sx={{
                position: "relative",
                width: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={thumbnail}
                alt="Vídeo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* Botão Play */}
              <Box
                sx={{
                  position: "absolute",
                  width: "70px",
                  height: "70px",
                  background: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="35" height="35" viewBox="0 0 24 24" fill="#fff">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </Box>
            </Box>
          )}
        </VideoContent>
      </AboutUsContent>
    </AboutUsComp>
  );
};

export { Video };
